// extracted by mini-css-extract-plugin
export var boxItems = "_al-1";
export var boxItemsLg = "_al-2";
export var button = "_al-7";
export var buttonHoverless = "_al-9";
export var buttonLg = "_al-8";
export var filterGroupBox = "_al-0";
export var icon = "_al-3";
export var iconSecondary = "_al-6";
export var iconWrapper = "_al-4";
export var iconWrapperLg = "_al-5";
export var truncatedLabel = "_al-a";